import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber4 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm1.518 4.037H8.094L4.598 8.57V9.7h3.507v2.202h1.413V9.7h1.507V8.63H9.518V4.036zm-1.412 1.65v2.942H5.869v-.047l2.19-2.896h.047z" />
    </g>
  );
};

export default withIcon(IconNumber4);
